import { render, staticRenderFns } from "./addPurchaseReturns.vue?vue&type=template&id=d37ad5ec&scoped=true"
import script from "./addPurchaseReturns.vue?vue&type=script&lang=js"
export * from "./addPurchaseReturns.vue?vue&type=script&lang=js"
import style0 from "./addPurchaseReturns.vue?vue&type=style&index=0&id=d37ad5ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37ad5ec",
  null
  
)

export default component.exports